import { render, staticRenderFns } from "./AmsaPagination.vue?vue&type=template&id=74f8e484&"
import script from "./AmsaPagination.vue?vue&type=script&lang=js&"
export * from "./AmsaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports